export default (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 14.063">
        <path
            d="M14.285 2.289H7.999a.573.573 0 0 1-.457-.229L6.514.688A1.723 1.723 0 0 0 5.143.003H1.714A1.716 1.716 0 0 0 0 1.717v10.632a1.716 1.716 0 0 0 1.714 1.714h12.571a1.716 1.716 0 0 0 1.714-1.714V4.001a1.716 1.716 0 0 0-1.714-1.714Zm.571 10.063a.572.572 0 0 1-.571.571H1.714a.572.572 0 0 1-.571-.571V1.714a.572.572 0 0 1 .571-.571h3.429a.574.574 0 0 1 .457.229l1.029 1.372A1.723 1.723 0 0 0 8 3.429h6.286a.572.572 0 0 1 .571.571Z"
            fill="#808080"
        />
    </svg>
)
